import axios, {AxiosError, type AxiosInstance} from 'axios';

const baseConfig = {
    baseURL: import.meta.env.VITE_BASE_URI || '',
};

const httpClient = configureAxios(axios.create(baseConfig), 'http-client.ts');
export {httpClient};

function configureAxios(axios: AxiosInstance, logFileName: string = 'http-client.ts') {
    axios.defaults.headers.get.Pragma = 'no-cache';
    axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store, must-revalidate';

    axios.interceptors.response.use(
        (response) => response,
        (error) => errorHandler(error, logFileName),
    );
    return axios;
}

function errorHandler(error: AxiosError, logFileName: string) {
    if (error.code === 'ERR_CANCELED') {
        return Promise.reject(error);
    }
    return Promise.reject(error);
}
